/** @var {resources} */
import commonEn from './locales/common/en.json'
import commonId from './locales/common/id.json'
import commonTh from './locales/common/th.json'
import liveTrackingEn from './locales/liveTracking/en.json'
import liveTrackingId from './locales/liveTracking/id.json'
import liveTrackingTh from './locales/liveTracking/th.json'
import signupEn from './locales/signup/en.json'
import signupId from './locales/signup/id.json'
import signupTh from './locales/signup/th.json'

const resources = {
  en: {
    translation: {
      common: commonEn,
      signup: signupEn,
      liveTracking: liveTrackingEn,
    },
  },
  id: {
    translation: {
      common: commonId,
      signup: signupId,
      liveTracking: liveTrackingId,
    },
  },
  th: {
    translation: {
      common: commonTh,
      signup: signupTh,
      liveTracking: liveTrackingTh,
    },
  },
}

export default resources
